import React from 'react';
import PropTypes from 'prop-types';
import { Loader, Popup } from 'semantic-ui-react';
import { SECONDARY_COLOR, SECONDARY_COLOR_HIGHLIGHT } from '../colors';
import { SIZE_BIG, SIZE_MEDIUM, SIZE_SMALL } from '../constants';
import './index.css';

/**
 * Status component
 * show a status element
 * Parameters (Props):
 * @param svg object svgImage: image shows within the box
 * @param bool disable
 * @param object stylesBox: styles of the outside box
 * @param function onClick
 * @param string size: default medium [small, medium, big]
 * @param string tooltip
 * @param bool inverted
 * @param string label
 * @param string color
 * @param func toggleHover: call back function to set the hover
 */
export default class Status extends React.PureComponent {
  constructor(props) {
    super(props);
    this.toggleHover = this.toggleHover.bind(this);
    this.state = {
      hover: false,
    };
  }

  /**
   * Toggle hover
   */
  toggleHover() {
    const { toggleHover } = this.props;
    const { hover } = this.state;
    this.setState({ hover: !hover });
    if (toggleHover !== null) {
      toggleHover();
    }
  }

  render() {
    const {
      svgImage,
      disable,
      stylesBox,
      onClick,
      tooltip,
      inverted,
      label,
      color,
      loading,
    } = this.props;

    const { hover } = this.state;
    /* Color definition */
    const styleButton =
      hover && !inverted && onClick
        ? { backgroundColor: SECONDARY_COLOR_HIGHLIGHT }
        : { backgroundColor: SECONDARY_COLOR };

    let { size } = this.props;
    if (size !== SIZE_BIG && size !== SIZE_SMALL && size !== SIZE_MEDIUM) {
      size = SIZE_MEDIUM;
    }
    if (label !== null) {
      size = `${size}-label`;
    }
    const status = (
      <div
        role="button"
        tabIndex={0}
        onKeyPress={() => {}}
        style={{ ...styleButton, ...{ color }, ...stylesBox }}
        className={`status ${onClick ? 'button' : ''} ${
          disable ? 'disable' : ''
        } ${size}`}
        onClick={onClick}
        onMouseEnter={this.toggleHover}
        onMouseLeave={this.toggleHover}
      >
        {label !== null && <div className={`label ${size}`}>{label}</div>}
        {svgImage}
        {onClick && (!disable || hover) && (
          <span style={{ backgroundColor: color }} className="dot" />
        )}
        {loading && <Loader active inverted />}
      </div>
    );
    if (tooltip) {
      return <Popup trigger={status} content={tooltip} />;
    }
    return status;
  }
}

Status.propTypes = {
  svgImage: PropTypes.object.isRequired,
  disable: PropTypes.bool.isRequired,
  stylesBox: PropTypes.object,
  onClick: PropTypes.func,
  size: PropTypes.string,
  tooltip: PropTypes.string,
  inverted: PropTypes.bool,
  label: PropTypes.string,
  color: PropTypes.string,
  toggleHover: PropTypes.func,
};

Status.defaultProps = {
  stylesBox: {},
  onClick: null,
  size: 'medium',
  tooltip: '',
  inverted: false,
  label: null,
  toggleHover: null,
};
